import React from 'react'
import {Button, Flex} from '../../vanilla'
import useNavigation from '../../hooks/use-navigation'
import {isServer} from '../../utils/utils'
import { Cookies, LocalStorage, SessionStorage } from '../../utils/storages'
import { resetShoppingButtonsContainer } from './styles.css'

export const ResetAndContinueShoppingButtons = () => {
  const navigate = useNavigation()

  const resetSession = () => {
    if (isServer) return

    Cookies.clear()
    LocalStorage.clear()
    SessionStorage.clear()

    navigate('/')
  }

  return (
    <Flex className={resetShoppingButtonsContainer}>
      <Button
        variant="red"
        data-test-selector="continue-shopping-button"
        width='full'
        onClick={() => {
          resetSession()
        }}
      >
        Reset & Continue Shopping
      </Button>
      <Button
        variant="outlineLight"
        data-test-selector="cancel-return-home"
        width='full'
        onClick={() => {
          navigate('/')
        }}
      >
        Cancel & Return Home
      </Button>
    </Flex>
  )
}
